import { SORT_FIELDS, SORT_MODES } from "@/lib/teamSort";

/**
 * Four independent sort toggles (Gender / Age / Grade / Year), each Off / Asc / Desc.
 * `value` is a { gender, age, grade, year } map; `onChange(next)` gets the updated map.
 */
export default function RosterSortControls({ value, onChange, testidPrefix = "roster-sort" }) {
    return (
        <div className="inline-flex items-center gap-3 flex-wrap" data-testid={`${testidPrefix}-controls`}>
            <span className="text-[9px] uppercase tracking-[0.2em] text-[#a0a0a0]">Sort</span>
            {SORT_FIELDS.map(([field, label]) => (
                <label key={field} className="inline-flex items-center gap-1">
                    <span className="text-[9px] uppercase tracking-[0.2em] text-[#a0a0a0]">{label}</span>
                    <select
                        data-testid={`${testidPrefix}-${field}`}
                        value={value[field] || "off"}
                        onChange={(e) => onChange({ ...value, [field]: e.target.value })}
                        className="h-7 text-[11px] bg-[#0f0f0f] border border-[#2a2a2a] text-[#e5e5e5] px-1.5 rounded-none focus:outline-none focus:border-[#ff4500]"
                    >
                        {SORT_MODES.map(([v, l]) => (
                            <option key={v} value={v}>{l}</option>
                        ))}
                    </select>
                </label>
            ))}
        </div>
    );
}
